import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
// 获取基础的筛选项
import { OK } from '@/common';
import { getStudio } from '@/api/payManage/appManage';
import { getQueryList, queryAccountList } from '@/api/payManage/accountManage';
export const useBasicOptions = () => {
  const studioList = ref([]); // 工作室列表
  const accountList = ref([]); // 账号列表
  const companyList = ref([]); // 主体列表
  // 获取工作室列表的函数
  const getStudioList = async () => {
    try {
      const {
        code,
        data
      } = await getStudio();
      if (code === OK) {
        var _data$map;
        studioList.value = (_data$map = data === null || data === void 0 ? void 0 : data.map(item => ({
          ...item,
          label: item.name,
          value: item.name
        }))) !== null && _data$map !== void 0 ? _data$map : [];
      }
    } catch (error) {
      console.error(error);
    }
  };
  // 获取账号列表的函数
  const getAccountList = async () => {
    try {
      const {
        code,
        data: {
          list
        }
      } = await queryAccountList({
        pageNum: 1,
        pageSize: 9999999
      });
      if (code === OK) {
        var _list$filter$map;
        // 使用Set来过滤重复的accountName值
        const uniqueAccountNames = new Set();
        accountList.value = (_list$filter$map = list === null || list === void 0 ? void 0 : list.filter(item => {
          if (uniqueAccountNames.has(item.accountName)) {
            return false;
          }
          uniqueAccountNames.add(item.accountName);
          return true;
        }).map(item => ({
          ...item,
          label: item.accountName,
          value: item.accountName
        }))) !== null && _list$filter$map !== void 0 ? _list$filter$map : [];
      }
    } catch (error) {
      console.error(error);
    }
  };
  // 获取主体列表的函数
  const getCompanyList = async () => {
    try {
      const {
        code,
        data
      } = await getQueryList({
        pageNum: 1,
        pageSize: 9999999
      });
      if (code === OK) {
        var _data$filter$map;
        // 使用Set来过滤重复的mchName值
        const uniqueMchNames = new Set();
        companyList.value = (_data$filter$map = data === null || data === void 0 ? void 0 : data.filter(item => {
          if (uniqueMchNames.has(item.mchName)) {
            return false;
          }
          uniqueMchNames.add(item.mchName);
          return true;
        }).map(item => ({
          ...item,
          label: item.mchName,
          value: item.mchName
        }))) !== null && _data$filter$map !== void 0 ? _data$filter$map : [];
      }
    } catch (error) {
      console.error(error);
    }
  };
  onBeforeMount(() => {
    getStudioList();
    getAccountList();
    getCompanyList();
  });
  return {
    studioList,
    accountList,
    companyList
  };
};